<template>
  <div style="margin-top: -68px">
    <div class="weekConBox">
      <div class="weekConBox_title">
        <cl-tabs
          class="pl24"
          itemW="auto"
          minWidth="154px"
          :options="copyDimensionList"
          v-model="activeTab"
          @tab-click="getEvalSmallList"
          active-bg-color="#ffffff"
          defaultBgColor="#FBFBFB"
          defaultColor="#B7B7BF"
          tabKey="id"
          :tabTitle="'name' + $lang2 || 'name' + $lang"
          :noI18n="true"
        ></cl-tabs>
      </div>

      <div class="current" v-if="Object.keys(currentEval).length">
        <div
          v-for="ele in currentEval.items"
          :key="ele.id"
          class="count_item"
          :class="{ Summary: ele.type == 'input' }"
        >
          <div class="count_Ichild_block" v-if="ele.type == 'star'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="ele.name"
              :disabled="ele.name.length < 25"
              placement="top-start"
            >
              <span class="count_Ichild_name Text_Over_Two">
                {{ ele["name"] }}
              </span>
            </el-tooltip>
            <span class="count_Ichild_rate AkrobatM">{{ ele.data }}</span>
          </div>

          <div class="count_Ichild_block" v-if="ele.type == 'select'">
            <span class="count_Ichild_name">{{
              ele["name" + $lang] || ele["name" + $lang2]
            }}</span>
            <span class="count_Ichild_rate AkrobatM">{{ ele.data }}</span>
          </div>

          <div class="count_Ichild_block" v-if="ele.type == 'radio'">
            <span class="count_Ichild_name">{{
              ele["name" + $lang] || ele["name" + $lang2]
            }}</span>
            <span class="Summary-cont AkrobatM">{{
              getRadioText(ele.data)
            }}</span>
          </div>

          <div class="Summary" v-if="ele.type == 'input'">
            <p class="Summary-title">
              {{ ele["name" + $lang] || ele["name" + $lang2] }}
            </p>
            <div class="Summary-cont">{{ ele.data }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cl-eval-view",
  props: {
    // 球员评估详情
    dimensionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentEval: {}, // 当前评估小项
      tabsList: [],
      showReport: [],
      activeTab: "",
      radioOptions: [
        { label: this.$t("common.是"), value: "1" },
        { label: this.$t("common.否"), value: "0" },
      ],
      copyDimensionList: [], // 用来显示名称的模板项副本
    };
  },
  watch: {
    dimensionList: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.length) {
          this.copyDimensionList = val.map((item) => {
            return {
              title: item["name"],
              name: item["name"],
              key: item.name,
              not$t: true,
            };
          });
          console.log(val, "val");
          this.activeTab = val[0].name;
          this.getEvalSmallList();
        }
      },
    },
  },
  methods: {
    getEvalSmallList() {
      this.currentEval = this.dimensionList.find(
        (item) => item.name === this.activeTab
      );
    },
    // 获取radio的文本
    getRadioText(data) {
      if (!data) {
        return "";
      }
      const obj = this.radioOptions.find((item) => item.value === data);
      return obj ? obj.label : "";
    },
  },
};
</script>

<style scoped lang="scss">
.weekConBox {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0 20px 0;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  position: relative;
  .weekConBox_title {
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow: hidden;
    /deep/ .cl_tabs_wrapper {
      overflow-x: auto;
    }
  }

  .current {
    box-sizing: border-box;
    background-color: #fff;
    padding-bottom: 20px;
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    .count_item {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      font-size: 14px;
    }
    .flexRow {
      display: flex;
      flex-flow: row wrap;
    }
    .count_Ichild_block {
      width: 230px;
      height: 54px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      align-items: center;
      background: #fafafa;
      border-radius: 10px;
      margin-left: 20px;
      padding: 0 20px;
      margin-top: 14px;
    }
    .count_Ichild_name {
      display: inline-block;
      color: $base-font-minor;
      font-size: 14px;
      line-height: 20px;
      width: 200px;
      padding-right: 15px;
    }
    .count_Ichild_rate {
      font-size: 22px;
      margin-right: 10px;
      color: $base-font-minor;
    }
  }
}
.Summary {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-right: 30px;
  padding-top: 20px;
  font-size: 14px;
  .Summary-title {
    line-height: 22px;
    font-weight: 700;
    color: $base-font-major;
    padding-bottom: 16px;
  }
  .Summary-cont {
    width: 100%;
    line-height: 25px;
    color: $base-font-minor;
    overflow: hidden;
    overflow-y: auto;
  }
}
</style>
